import React, { createContext, useContext, useMemo } from 'react'
import { useAsyncResource } from '../hooks/useAsyncResource'
import { getListings } from '../services/cms'

import listingsHamptonsJson from '../data/rets-listing.json'
import listingsMontanaJson from '../data/montana-listing.json'
import listingsIslandsLocalJson from '../data/islands-listing.json'

const ListingsContext = createContext(null)

const byPriceDesc = (a, b) => (b?.listing_details?.current_price || 0) - (a?.listing_details?.current_price || 0)

function prepareLocalBuckets () {
  const listingsHamptons = (listingsHamptonsJson || []).slice().sort(byPriceDesc)
  const listingsMontana = (listingsMontanaJson || []).slice().sort(byPriceDesc)
  return { listingsHamptons, listingsMontana }
}

function splitListings (apiArray) {
  const camelized = apiArray || []
  const listings = []
  const listingsIslands = (listingsIslandsLocalJson || []).slice()

  for (const l of camelized) {
    if (l?.location?.city === 'U.S. Virgin Islands') listingsIslands.push(l)
    else listings.push(l)
  }

  return {
    listings: listings.sort(byPriceDesc),
    listingsIslands: listingsIslands.sort(byPriceDesc)
  }
}

export function ListingsProvider ({ children }) {
  const { listingsHamptons, listingsMontana } = useMemo(() => prepareLocalBuckets(), [])

  const listingsResource = useAsyncResource(async (signal) => {
    try {
      const raw = await getListings({ signal })
      return splitListings(raw)
    } catch {
      // fallback: only local islands if remote fails
      return splitListings([])
    }
  })

  const value = {
    listings: listingsResource.data?.listings ?? null,
    listingsIslands: listingsResource.data?.listingsIslands ?? null,
    listingsHamptons,
    listingsMontana,
    isListingsLoading: listingsResource.loading,
    listingsError: listingsResource.error,
    fetchListingsData: listingsResource.load
  }

  return <ListingsContext.Provider value={value}>{children}</ListingsContext.Provider>
}

export const useListings = () => {
  const ctx = useContext(ListingsContext)
  if (!ctx) throw new Error('useListings must be used within <ListingsProvider>')
  return ctx
}
